module.exports = __webpack_public_path__ + "img/1.ea6203a2.png";